import styled, { css, type DefaultTheme } from 'styled-components'

import { ChipSize, ChipVariant } from './chip'

const variantStyles = (variant: ChipVariant, theme: DefaultTheme) => {
  switch (variant) {
    case 'active':
      return css`
        background-color: ${theme.colors.marketShopBrand800};
        color: ${theme.colors.white};
        border-color: ${theme.colors.marketShopBrand800};
      `
    case 'red':
      return css`
        background-color: ${theme.colors.marketShopChipRed};
        color: ${theme.colors.white};
        border-color: ${theme.colors.marketShopChipRed};
      `
    case 'green':
      return css`
        background-color: ${theme.colors.marketShopChipGreen};
        color: ${theme.colors.white};
        border-color: ${theme.colors.marketShopChipGreen};
      `
    case 'default':
    default:
      return css`
        background-color: ${theme.colors.white};
        color: ${theme.colors.black500};
        border-color: ${theme.colors.gray400};
      `
  }
}

const sizeStyles = (size: ChipSize, theme: DefaultTheme) => {
  switch (size) {
    case 'small':
      return css`
        padding: ${theme.space['4']} ${theme.space['8']};
        font-size: 1.2rem;
      `
    case 'medium':
    default:
      return css`
        padding: ${theme.space['8']} ${theme.space['16']};
        font-size: 1.4rem;
      `
  }
}

export const Button = styled.button<{ $variant: ChipVariant; $size: ChipSize }>(
  ({ theme, $variant, $size }) => css`
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: fit-content;
    gap: ${theme.space['4']};
    cursor: pointer;
    overflow: initial;
    margin: 0;
    user-select: none;
    border: ${theme.border.size['1']} solid transparent;
    border-radius: ${theme.border.radius.full};
    outline: none;
    line-height: 1;
    font-weight: 500;
    text-transform: capitalize;
    transition: all ${theme.transition.duration.md} ease;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${theme.border.size['1']};
    }

    ${sizeStyles($size, theme)}
    ${variantStyles($variant, theme)}
  `,
)
